import {DotIcon} from '@primer/octicons-react'
import iconStyles from '../../Icon.module.css'

import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'

export function SkippedIcon({state}: {state?: RebaseState}) {
  if (state !== RebaseState.Skipped) return null

  return <DotIcon size={16} className={`color-fg-muted ${iconStyles.alignedAfterDot}`} />
}
